import React from 'react';
import { ReminderFeed } from '~/components/Reminders';
import { usePatientService } from '~/services';

interface RiskGapRemindersProps {
    riskGapId: number;
    patientId: number;
    addReminderOpen?: boolean;
}

export function RiskGapReminders({
    riskGapId,
    patientId,
    addReminderOpen = false,
}: RiskGapRemindersProps) {
    const { updateRiskGap } = usePatientService();
    async function performAdd(description: string, dueDate: string) {
        await updateRiskGap(riskGapId, patientId, {
            tasks: [{ description, due_at: dueDate }],
        });
    }
    return (
        <ReminderFeed
            performAdd={performAdd}
            loadEntity={`risk_gap.id=${riskGapId}`}
            addReminderOpen={addReminderOpen}
            isPCMView
        />
    );
}
